
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import dynamic from "next/dynamic"

import Default from "@/templates/Default"

const FavouritesView = dynamic(() => import("@/views/favourites"), {
  ssr: false,
})

function FavouritesPage() {
  return (
    <>
      {/* <meta name="robots" content="noindex,nofollow" /> */}
      <FavouritesView />
    </>
  )
}

FavouritesPage.Layout = Default

export default FavouritesPage


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/favourites',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  